function _nullishCoalesce(lhs, rhsFn) {
  if (lhs != null) {
    return lhs;
  } else {
    return rhsFn();
  }
}
export default class QuickLinks extends HTMLElement {
  constructor(...args) {
    super(...args);
    QuickLinks.prototype.__init.call(this);
    QuickLinks.prototype.__init2.call(this);
  }
  __init() {
    this.links = [];
  }
  __init2() {
    this.label = "";
  }
  connectedCallback() {
    this.links = JSON.parse(_nullishCoalesce(this.getAttribute("links"), () => "[]"));
    this.label = _nullishCoalesce(this.getAttribute("label"), () => "Select Option");
    if (!this.shadowRoot) {
      this.attachShadow({
        mode: "open"
      });
      this.render();
    }
  }
  selectOption(event) {
    const selectedLink = this.links.find(link => link.route === event.target.value);
    if (selectedLink) {
      window.location.href = selectedLink.route;
    } else {
      console.warn("Selected option does not have a corresponding link:", event.target.value);
    }
  }
  render() {
    const {links} = this;
    const optionsListHtml = [{
      route: "default",
      label: this.label
    }, ...links].map(link => {
      return `<option value="${link.route}">${link.label}</option>`;
    }).join("\n");
        const template = document.createElement('template');
    template.innerHTML = `<select name="quick-links-dropdown" onchange="this.getRootNode().host.selectOption(event)">
        ${optionsListHtml}
      </select>`;
    if (!this.shadowRoot) {
      this.attachShadow({
        mode: 'open'
      });
      this.shadowRoot.appendChild(template.content.cloneNode(true));
    } else {
      this.shadowRoot.innerHTML = template.innerHTML;
    }

  }
}
customElements.define("as-quick-links", QuickLinks);
